import React from 'react'
import { Control, FieldErrors, UseFormSetValue } from 'react-hook-form'
import { DropdownOption } from 'types'

import { EntryNames, FormController } from './FormController'
import { ImportInspectionSchema } from './importInspectionSchema'

type EntryFormControllerProps = {
  control: Control<ImportInspectionSchema>
  errors: FieldErrors<ImportInspectionSchema>
  setValue: UseFormSetValue<ImportInspectionSchema>
  onOrgChange: (newOrgID: string) => void
  onSiteChange: (newSiteID: string) => void
  onUnitChange: (newUnitID: string) => void
  onInspectionSlugChange: (slug: string) => void
  options: {
    inspectionOptions: DropdownOption[]
    orgOptions: DropdownOption[]
    siteOptions: DropdownOption[]
    jobOptions: DropdownOption[]
    unitOptions: DropdownOption[]
    componentOptions: DropdownOption[]
  }
}

export const EntryFormController = ({
  control,
  errors,
  setValue,
  onOrgChange,
  onSiteChange,
  onUnitChange,
  onInspectionSlugChange,
  options,
}: EntryFormControllerProps) => {
  const fields = [
    {
      name: 'inspection_slug',
      label: 'Slug',
      testID: 'inspection-slug-combobox',
      options: options.inspectionOptions,
      onChange: onInspectionSlugChange,
    },
    {
      name: 'organization',
      label: 'Organization',
      testID: 'organization-combobox',
      options: options.orgOptions,
      onChange: onOrgChange,
      clearDependents: true,
    },
    {
      name: 'site',
      label: 'Site',
      testID: 'site-combobox',
      options: options.siteOptions,
      onChange: onSiteChange,
      clearDependents: true,
    },
    {
      name: 'job',
      label: 'Job',
      testID: 'job-combobox',
      options: options.jobOptions,
    },
    {
      name: 'unit',
      label: 'Unit',
      testID: 'unit-combobox',
      options: options.unitOptions,
      onChange: onUnitChange,
      clearDependents: true,
    },
    {
      name: 'component',
      label: 'Component',
      testID: 'component-combobox',
      options: options.componentOptions,
    },
  ]

  return (
    <>
      {fields.map((field) => (
        <FormController
          key={field.name as string}
          name={field.name as EntryNames}
          label={field.label}
          testID={field.testID}
          options={field.options}
          control={control}
          errors={errors}
          onChangeFn={field.onChange}
          clearDependentFields={
            field.clearDependents
              ? () => {
                  if (field.name === 'organization') {
                    setValue('site', '')
                    setValue('job', '')
                    setValue('unit', '')
                    setValue('component', '')
                  }
                  if (field.name === 'site') {
                    setValue('job', '')
                    setValue('unit', '')
                    setValue('component', '')
                  }
                  if (field.name === 'unit') {
                    setValue('component', '')
                  }
                }
              : undefined
          }
        />
      ))}
    </>
  )
}
